import angular from 'angular';
import _ from 'lodash';

const productsStoreFactory = ($log, $rootScope, Dispatcher, StoreStates) => {
  'ngInject';

  const products = {
    state: StoreStates.STORE_EMPTY,
    list: [],
    error: undefined,
    pagination: {} 
  };

  const allProducts = {
    state: StoreStates.STORE_EMPTY,
    list: [],
    error: undefined,
    pagination: {} 
  };

  const categories = {
    state: StoreStates.STORE_EMPTY,
    list: [],
    error: undefined
  };

  let subCategories = {};

  const saveSubCategories = (parentKey, state, list, error) => {
    if (parentKey in subCategories) {
      subCategories[parentKey].state = state;
      subCategories[parentKey].list = list;
      subCategories[parentKey].error = error;
    } else {
      subCategories[parentKey] = {
        state,
        list,
        error
      };
    }
  };

  const sortProducts = unsortedProducts => _.sortBy(unsortedProducts, [product => product.category.name, product => product.subCategory.name, 'name']);

  const deleteProduct = productId => {
    const productIndex = _.findIndex(products.list, {
      id: productId
    });

    if (productIndex > -1) {
      products.list.splice(productIndex, 1);
    }
  };

  const saveProductAvailability = (productId, available) => {
    const product = _.find(products.list, {
      id: productId
    });

    if (product) {
      product.available = available;
    }
  };

  const getSubCategories = parentKey => {
    if (!(parentKey in subCategories)) {
      subCategories[parentKey] = {
        state: StoreStates.STORE_EMPTY,
        list: [],
        error: undefined
      };
    }

    return subCategories[parentKey];
  };

  const notifyProductsChange = () => {
    $rootScope.$broadcast('PRODUCTS_UPDATE');
  };

  const notifyAllProductsLoad = () =>{
    $rootScope.$broadcast('ALL_PRODUCTS_LOAD');
  };

  const notifyProductsFail = () => {
    $rootScope.$broadcast('PRODUCTS_FAIL');
  };

  const notifySaveProductFail = () => {
    $rootScope.$broadcast(`SAVEPRODUCT_FAIL`);
  };

  const notifySaveProduct = () => {
    $rootScope.$broadcast('SAVEPRODUCT');
  };

  const notifySaveProductAvailability = productId => {
    $rootScope.$broadcast(`SAVEPRODUCT_AVAILABILITY_${productId}`);
  };

  const notifySaveProductAvailabilityFail = productId => {
    $rootScope.$broadcast(`SAVEPRODUCT_AVAILABILITY_FAIL_${productId}`);
  };

  const notifyCategoriesChange = () => {
    $rootScope.$broadcast('CATEGORIES_UPDATE');
  };

  const notifyCategoriesFail = () => {
    $rootScope.$broadcast('CATEGORIES_FAIL');
  };

  const notifySubCategoriesChange = parentKey => {
    $rootScope.$broadcast(`SUBCATEGORIES_UPDATE_${parentKey}`);
  };

  const notifySubCategoriesFail = parentKey => {
    $rootScope.$broadcast(`SUBCATEGORIES_FAIL_${parentKey}`);
  };

  Dispatcher.register(action => {
    switch (action.actionType) {
      case 'PRODUCTS_LOAD_START':
        products.error = undefined;
        products.list = [];
        products.state = action.state;
        break;
      case 'PRODUCTS_LOAD_FAIL':
        products.error = action.data.reason;
        products.state = action.state;
        products.list = [];
        notifyProductsFail();
        break;
      case 'PRODUCTS_LOAD':
        products.error = undefined;
        products.state = action.state;
        products.list = sortProducts(action.data.products);
        products.pagination = action.data.pagination;
        notifyProductsChange();
        break;
      case 'ALL_PRODUCTS_LOAD':
        allProducts.error = undefined;
        allProducts.state = action.state;
        allProducts.list = sortProducts(action.data.products);
        allProducts.pagination = action.data.pagination;
        products.state = StoreStates.STORE_EXPIRED
        notifyAllProductsLoad();
        break;
      case 'SAVEPRODUCT_START':
        products.error = undefined;
        products.state = action.state;
        break;
      case 'SAVEPRODUCT_FAIL':
        products.error = action.data.reason;
        products.state = action.state;
        notifySaveProductFail();
        break;
      case 'SAVEPRODUCT_AVAILABILITY':
        saveProductAvailability(action.data.productId, action.data.available);
        products.error = undefined;
        products.state = action.state;
        notifySaveProductAvailability(action.data.productId);
        break;
      case 'SAVEPRODUCT_AVAILABILITY_FAIL':
        products.error = action.data.reason;
        products.state = action.state;
        notifySaveProductAvailabilityFail(action.data.productId);
        break;
      case 'SAVEPRODUCT_CREATED':
        products.error = undefined;
        products.state = action.state;
        // saveProduct(action.data.product);
        notifyProductsChange();
        notifySaveProduct();
        break;
      case 'SAVEPRODUCT_EDITED':
        products.error = undefined;
        products.state = action.state;
        // saveProduct(action.data.product);
        notifySaveProduct();
        notifyProductsChange();
        break;
      case 'SAVEPRODUCT_DELETED':
        products.error = undefined;
        products.state = action.state;
        deleteProduct(action.data.productId);
        notifyProductsChange();
        break;
      case 'CATEGORIES_LOAD_START':
        categories.error = undefined;
        categories.state = action.state;
        categories.list = [];
        break;
      case 'CATEGORIES_LOAD_FAIL':
        categories.state = action.state;
        categories.error = action.data.reason;
        categories.list = [];
        notifyCategoriesFail();
        break;
      case 'CATEGORIES_LOAD':
        categories.state = action.state;
        categories.list = action.data.categories;
        categories.error = undefined;
        notifyCategoriesChange();
        break;
      case 'SUBCATEGORIES_LOAD_START':
        saveSubCategories(action.data.parentKey, action.state, []);
        break;
      case 'SUBCATEGORIES_LOAD_FAIL':
        saveSubCategories(action.data.parentKey, action.state, [], action.data.reason);
        notifySubCategoriesFail(action.data.parentKey);
        break;
      case 'SUBCATEGORIES_LOAD':
        saveSubCategories(action.data.parentKey, action.state, action.data.subCategories);
        notifySubCategoriesChange(action.data.parentKey);
        break;
      case 'GLOBAL_CLEAN':
        products.state = StoreStates.STORE_EMPTY;
        products.list = [];
        products.error = undefined;
        categories.state = StoreStates.STORE_EMPTY;
        categories.list = [];
        categories.error = undefined;
        subCategories = {};
        break;
      default:
        break;
    }
  });

  const store = {
    forceExpired:() =>  products.state = StoreStates.STORE_EXPIRED,
    forceCategoryExpired: () => categories.state = StoreStates.STORE_EXPIRED,
    getProductsStoreState: () => products.state,
    getProducts: () => angular.copy(products),
    getAllProductsStoreState: () => allProducts.state,
    getAllProducts: () => angular.copy(allProducts),
    getProduct: id => angular.copy(_.find(products.list, {
      id
    })),
    searchProducts: terms => {
      const results = [];

      _.forEach(allProducts.list, product => {
        let found = false;

        _.forEach(terms, term => {
          const searchRegExp = new RegExp(`^.*${term}.*$`, 'i');
          if (searchRegExp.test(product.name)) {
            found = true;
            return false; // stop _.forEach
          }

          if (searchRegExp.test(product.description)) {
            found = true;
            return false;
          }

          if (searchRegExp.test(product.category.name)) {
            found = true;
            return false;
          }

          if (searchRegExp.test(product.subCategory.name)) {
            found = true;
            return false;
          }

          return true; // continue _.forEach
        });

        if (found) {
          results.push(product);
        }
      });

      return angular.copy(sortProducts(results));
    },
    getProductsByIds: (productIds, menu) => angular.copy(sortProducts(_.filter(menu.products, product => productIds.indexOf(product.id) > -1))),
    getProductsError: () => products.error,
    getCategoriesStoreState: () => categories.state,
    getCategories: () => angular.copy(categories.list),
    getCategoriesError: () => categories.error,
    getSubCategoriesStoreState: parentKey => getSubCategories(parentKey).state,
    getSubCategoriesError: parentKey => getSubCategories(parentKey).error,
    getSubCategories: parentKey => angular.copy(getSubCategories(parentKey).list)
  };

  return store;
};

export default productsStoreFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/stores/products.store.factory.js
 **/